<script setup>
import {useCustomizerStore} from "@/stores/customizer";

const {darkMode} = storeToRefs(useCustomizerStore());
</script>
<template>
  <div class="themed-component">
    <slot name="dark" v-if="darkMode"/>
    <slot name="light" v-else />
  </div>
</template>
